/** WhatsApp visual language for the Engagement → WhatsApp workspace. */
export const wa = {
  green: '#25D366',
  teal: '#128C7E',
  dark: '#075E54',
  deep: '#0B3B35',
  bubble: '#DCF8C6',
  chatBg: '#ECE5DD',
  tint: 'rgba(37,211,102,0.08)',
  tintBorder: 'rgba(18,140,126,0.18)',
  gradient: 'linear-gradient(135deg, #0B3B35 0%, #075E54 55%, #128C7E 100%)',
  cta: 'linear-gradient(135deg, #128C7E 0%, #25D366 100%)',
  ctaShadow: '0 6px 20px rgba(37,211,102,0.35)',
};

export const TEMPLATE_STATUS: Record<string, { label: string; color: string; bg: string }> = {
  approved: { label: 'Approved', color: '#1b5e20', bg: 'rgba(76,175,80,0.14)' },
  submitted: { label: 'In review', color: '#0d47a1', bg: 'rgba(33,150,243,0.12)' },
  draft: { label: 'Not submitted', color: '#616161', bg: 'rgba(0,0,0,0.06)' },
  rejected: { label: 'Rejected', color: '#b71c1c', bg: 'rgba(244,67,54,0.12)' },
  paused: { label: 'Paused by WhatsApp', color: '#e65100', bg: 'rgba(255,152,0,0.14)' },
  disabled: { label: 'Disabled', color: '#b71c1c', bg: 'rgba(244,67,54,0.12)' },
  not_registered: { label: 'Not linked', color: '#9e9e9e', bg: 'rgba(0,0,0,0.04)' },
};

export const WORKFLOW_STATUS: Record<string, { label: string; color: string; bg: string }> = {
  scheduled: { label: 'Scheduled', color: '#e65100', bg: 'rgba(255,152,0,0.14)' },
  processing: { label: 'Sending…', color: '#0d47a1', bg: 'rgba(33,150,243,0.12)' },
  sent: { label: 'Sent', color: '#1b5e20', bg: 'rgba(76,175,80,0.14)' },
  failed: { label: 'Failed', color: '#b71c1c', bg: 'rgba(244,67,54,0.12)' },
  cancelled: { label: 'Cancelled', color: '#616161', bg: 'rgba(0,0,0,0.06)' },
  active: { label: 'Running', color: '#1b5e20', bg: 'rgba(37,211,102,0.16)' },
  paused: { label: 'Paused', color: '#616161', bg: 'rgba(0,0,0,0.06)' },
};

/** Fill `{{1}}`-style slots from a named variable map, in template order. */
export function renderTemplate(
  body: string | undefined,
  variableOrder: string[] = [],
  values: Record<string, string | undefined> = {},
  placeholder = (name: string) => `[${name}]`,
): string {
  if (!body) return '';
  return variableOrder.reduce(
    (acc, name, i) =>
      acc.replace(new RegExp(`\\{\\{\\s*${i + 1}\\s*\\}\\}`, 'g'), values[name]?.trim() || placeholder(name)),
    body,
  );
}

export const prettyKey = (key: string) =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
